import * as React from 'react';
import { Label, MessageBar, PrimaryButton, MessageBarType } from 'office-ui-fabric-react';
import { Authority, AppId, Scopes } from '../../../lib/PageBase';
import * as Msal from "msal";
import './Login.scss';
import { ILoginProps, ILoginState } from '../../../interfaces/ILogin';
import { IError } from '../../../interfaces/IError';
import { setStorage, getStorage } from '../../../lib/LocalStorageService';
import { IsAuthenticated, UserName, IdToken } from '../../../constants/GlobalConstants';
import history from '../../../lib/history';

class Login extends React.Component<ILoginProps, ILoginState> {

  public msalInstance: any;

  constructor(props: ILoginProps) {
    super(props);
    this.state = {
      msalConfig: {
        auth: {
          clientId: AppId,
          authority: Authority
        }
      },
      loginRequest: {
        scopes: Scopes
      }
    };

  }

  componentDidMount() {
    this.msalInstance = new Msal.UserAgentApplication(this.state.msalConfig);
  }

  private async _signIn() {
    try {
      this.setState({ errorMessage: undefined });

      await this.msalInstance.loginPopup(this.state.loginRequest)
        .then((response: any) => {
          let _userName: string = response.account.name;
          setStorage(IsAuthenticated, "true");
          setStorage(UserName, _userName);
          let _idToken: string = response.idToken.rawIdToken;
          setStorage(IdToken, _idToken);

          window.location.href = "/";
        })
        .catch((err: IError) => {
          this.setState({
            errorMessage: err.message
          });
          console.log(err);
          console.log(err.message);
        });
    }
    catch (err) {
      var error = {};
      error = {
        message: err.message,
        debug: JSON.stringify(err)
      };
    }

  }

  public render() {
    if (getStorage(IsAuthenticated) == "true") {
      history.push("/dashboard");
    }
    return (
      <div className="container">
        {
          this.state.errorMessage &&
          <div className="row">
            <div className="col-12">
              <MessageBar messageBarType={MessageBarType.error} isMultiline={false} dismissButtonAriaLabel="Sluiten"><text>{this.state.errorMessage}</text></MessageBar>
            </div>
          </div>
        }
        <div className="row h-100vh text-center flex-column justify-content-center align-items-center">
          <div className="col-auto">
            <div className="row">
              <div className="col-12">
                <Label>Welkom in de meerwerkbonnen app.</Label>
              </div>
              <div className="col-12 mt-2">
                <Label>Log in met je bedrijfsaccount om te starten.</Label>
              </div>
              <div className="col-12">
                <PrimaryButton text="Inloggen" className="red-button mt-5" onClick={() => this._signIn()} allowDisabledFocus />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Login;
